import { useEffect } from "react";

/**
 * Refreshes the unauth token when the login page mounts or the user returns
 * to the tab/window after idle time (avoids 403s from expired Bearer tokens).
 */
export function useRefreshUnauthTokenOnFocus() {
  useEffect(() => {
    const refresh = () => {
      window.__authShellConfig?.refreshUnauthTokenIfNeeded?.()?.catch((error) => {
        console.warn("[useRefreshUnauthTokenOnFocus] Failed to refresh unauth token:", error);
      });
    };

    refresh();

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refresh();
      }
    };

    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);
}
